import {Component, Input, OnDestroy} from '@angular/core';
import {NgbActiveModal, NgbDateStruct, NgbInputDatepicker, NgbTypeahead} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule} from '@angular/forms';
import {NgForOf} from '@angular/common';
import {Observable, Subscription} from 'rxjs';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {LIST_STATUS, LIST_TYPE_COPIE} from "../../../../consts/status.const";
import {PlanningApiService} from "../../../../services/api/planning-api.service";
import {ToastService} from "../../../../services/toaster.service";
import {PlanningRegionApiService} from "../../../../services/api/planning-region-api.service";
import {dateUtils} from "../../../../helpers/date.utils";
import {BaseComponent} from "../../../base/base.component";
import {Cinema} from "../../../../models/cinema.model";
import {Screen} from "../../../../models/screen.model";
import {Version} from "../../../../models/transport.model";
import {SearchFilmService} from "../../../../services/search-film.service";

@Component({
  selector: 'app-add-reservation-modal',
  templateUrl: './planning-region-add-reservation-modal.component.html',
  styleUrls: ['./planning-region-add-reservation-modal.component.scss'],
  standalone: true,
  imports: [FormsModule, NgForOf, NgbTypeahead, TranslateModule, NgbInputDatepicker],
})
export class PlanningRegionAddReservationModalComponent extends BaseComponent implements OnDestroy {
  @Input() screen!: Screen;
  @Input() cinema!: Cinema;
  @Input() date!: NgbDateStruct;
  @Input() title: string = '';
  @Input() wednesday: string = '';


  taux: number | null = 50;
  duration: number | null = 1;
  durationType: string = '7';
  versions: Version[] = [];
  selectedVersions: string[] = [];
  copyTypes: any = LIST_TYPE_COPIE;
  listStatus: any = LIST_STATUS;
  copyType: string = 'STD';
  reservationStatus: number = 6;
  films: any[] = [];
  selectedFilm: any = null;
  pdc: boolean = false;
  adrc: boolean = false;

  private subscriptions: Subscription = new Subscription();

  constructor(
    public activeModal: NgbActiveModal,
    private planningApiService: PlanningApiService,
    private toastService: ToastService,
    private planningRegionApiService: PlanningRegionApiService,
    private translate: TranslateService,
    private searchFilmService: SearchFilmService,
  ) {
    super();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  closeModal(): void {
    this.activeModal.close();
  }

  searchFilms = (text$: Observable<string>) => this.searchFilmService.searchFilms(text$, this.cookies);

  formatter = (film: any) => this.searchFilmService.formatter(film);

  searchFilmVersions(idFilm: number): void {
    const subscription = this.searchFilmService.searchFilmVersions(this.cookies, idFilm)
      .subscribe(({ versions, selectedVersions }) => {
        this.versions = versions;
        this.selectedVersions = selectedVersions;
      });
    this.subscriptions.add(subscription);
  }

  onFilmSelect(event: any): void {
    this.selectedFilm = event.item;
    this.searchFilmVersions(this.selectedFilm.id_film);
  }

  toggleVersion(version: Version): void {
    const versionId = String(version.id_ver);
    const index = this.selectedVersions.indexOf(versionId);

    if (index > -1) {
      this.selectedVersions.splice(index, 1);
      version.checked = false;
    } else {
      this.selectedVersions.push(versionId);
      version.checked = true;
    }
  }

  addReservations(): void {
    if (!this.selectedFilm) {
      this.toastService.showDanger(this.translate.instant('toast.pleaseSelectFilm'));
      this.markFilmInputAsInvalid();
      return;
    }

    const params = {
      id_cinema: this.cinema.id_cinema,
      id_film: this.selectedFilm.id_film,
      screen_id: this.screen.screen_id,
      list_versions: this.selectedVersions,
      date_debut: dateUtils.formatDateStruct(dateUtils.toDate(this.date)),
      date_fin: this.calculateEndDate(this.date, this.duration, this.durationType),
      is_adrc: this.adrc,
      is_pdc: this.pdc,
      type_copie: this.copyType,
      etat: this.reservationStatus,
      taux: this.taux,
    };

    const subscription = this.planningApiService.addReservation(this.cookies, params)
      .subscribe(
        (data) => {
          if (data && data.warning) {
            this.toastService.showDanger(data.warning);
          } else {
            this.toastService.showSuccess(this.translate.instant('toast.reservationSavedSuccess'));
            this.planningRegionApiService.reloadPlanningRegion(this.idRegion);
          }
          this.activeModal.close();
        },
        () => this.toastService.showDanger(this.translate.instant('toast.errorAddingReservation'))
      );
    this.subscriptions.add(subscription);
  }

  private markFilmInputAsInvalid(): void {
    const filmInput = document.getElementById('filmInput');
    if (filmInput) {
      filmInput.classList.add('is-invalid');
    }
  }

  private calculateEndDate(startDate: NgbDateStruct, duration: number | null, type: string): string {
    const start = new Date(startDate.year, startDate.month - 1, startDate.day);
    const endDate = new Date(start);

    if (type === '7') {
      endDate.setDate(start.getDate() + (duration! * 6));
    }

    return dateUtils.formatDateStruct(endDate);
  }
}
